import EventEmitter from "./utils/EventEmitter";
import FontFaceObserver from 'fontfaceobserver'

export default class AgendaPage extends EventEmitter {
    constructor(element) {
        super();

        this.el = element;

        this.tabsButtons = this.el.querySelectorAll('.tabs-buttons-container .tab-button');
        this.tabsContents = this.el.querySelectorAll('[data-content-type]');
        this.agendaFlux = document.querySelector('.agenda-flux');
        this.mobileFiltersButton = document.querySelector('.agenda-mobile-filters-button');

        this.eventSpotlight = document.querySelector('.paragraph--key-event');

        const font = new FontFaceObserver('Sora')

        font.load().then(() => {
            if (this.eventSpotlight && this.tabsContents.length > 0) {
                this.insertEventSpotlight().then(() => {
                    this.eventSpotlight.remove()
                    if (this.agendaFlux.querySelector('.flux-future-events')) {
                        this.setTabHeight()
                    } else {
                        this.tabsButtons[0].classList.add('active')
                    }
                })
            } else {
                this.setTabHeight()
            }

            this.events()
            this.mobilePanelEvents()
        })
    }

    setTabHeight() {
        this.tabsContents.forEach((content) => {
            content.style.maxHeight = `${content.scrollHeight}px`;
            content.classList.add('active')

            if (content.classList.contains('force-closed')) {
                content.style.maxHeight = 0;
                content.style.opacity = 0;
                content.classList.remove('active')
            }
        })
    }

    events() {
        this.tabsButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                if (button.classList.contains('active'))
                    return

                this.tabsButtons.forEach((tabButton) => {
                    tabButton.classList.remove('active')
                })
                button.classList.add('active')

                // Scroll to top el
                const scrollToEl = document.querySelector('.tabs-buttons-container');
                window.scrollTo({
                    top: scrollToEl.getBoundingClientRect().top + window.scrollY - 25,
                    behavior: "smooth"
                })

                this.updateTabs(e.currentTarget.dataset.type);
            })
        })

        if (this.mobileFiltersButton) {
            this.mobileFiltersButton.addEventListener('click', () => {
                document.querySelector('[data-content-type].active .view-filters-mobile-panel').classList.toggle('active')
            })
        }
    }

    mobilePanelEvents() {
        document.querySelectorAll('.close-filters-button').forEach((button) => {
            button.addEventListener('click', () => {
                document.querySelector('[data-content-type].active .view-filters-mobile-panel').classList.remove('active')
            })
        })
    }

    updateTabs = (type) => {
        this.tabsContents.forEach((content) => {
            if (content.dataset.contentType === type) {
                content.style.maxHeight = `${content.scrollHeight}px`;
                content.style.opacity = 1;
                content.classList.add('active')
            } else {
                content.style.maxHeight = 0;
                content.style.opacity = 0;
                content.classList.remove('active')
            }
        })
    }

    insertEventSpotlight() {
        return new Promise((resolve) => {
            const viewContents = this.agendaFlux.querySelectorAll('.view-content');

            viewContents.forEach((viewContent) => {
                const viewContentChildren = Array.from(viewContent.children)
                const middleIndex = Math.floor(viewContentChildren.length / 2)
                const middleChild = viewContentChildren[middleIndex]
                const clone = this.eventSpotlight.cloneNode(true);

                // Si ya qu'un seul élément dans la liste, on l'ajoute à la fin
                if (viewContentChildren.length === 1) {
                    viewContent.appendChild(clone)
                    return
                }
                viewContent.insertBefore(clone, middleChild)
            })

            setTimeout(() => {
                resolve()
            },150)
        })
    }

    onAjaxComplete() {
        this.mobilePanelEvents()
    }

}
